import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-progress-ring',
	templateUrl:'./WaProgressRingPage.html',
	styles: [],
	styleUrls:['./WaProgressRingPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaProgressRingPage
{
	mdContent_427 = `\`\`\`java
import com.jwebmp.webawesome.components.progressring.WaProgressRing;
\`\`\``;
}
